import React from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import { Modal } from '@components';
import { TransFlags } from '../constant/loan';

const TransInfoModal = ({ transType }) => {
    const {
        LoanStore: { transInfoModalVisible, closeTransInfoModal },
    } = useStore();

    return (
        <Modal
            show={transInfoModalVisible}
            onHide={closeTransInfoModal}
            title={'提示訊息'}
        >
            <div>
                <div className="border-0">
                    <div className="icon_fast mx-auto "></div>
                    <div className="icon_info mx-auto mb-3"></div>
                    {TransFlags.filter(item => item.value === transType).map(
                        item =>
                            item.text.split('\n').map((line, idx) => {
                                return (
                                    <h4
                                        key={`line ${idx}`}
                                        className=" title fw-bolder text-center mt-3 lh-base"
                                    >
                                        {line}
                                    </h4>
                                );
                            })
                    )}
                    <div className="btn_box d-flex flex-column-reverse flex-sm-row justify-content-center">
                        <button
                            className="btn_check btn rounded-pill text-white"
                            type="button"
                            onClick={() => {
                                closeTransInfoModal();
                            }}
                        >
                            確認
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default observer(TransInfoModal);
